import { ALLOWED_BROWSER_LANGUAGES, AllowedBrowserLanguage } from '@core/enums/browser-language.enum';
import { Language } from '../enums/language.enum';

const getMappedBrowserLanguage = (language: AllowedBrowserLanguage): Language => {
  const languagesMap = {
    en: Language.EN,
    it: Language.IT,
  };

  return languagesMap[language];
};

export const getBrowserLanguage = () => {
  const browserLanguageFull = navigator.language;
  const browserLanguage = browserLanguageFull.split('-')[0];

  if (ALLOWED_BROWSER_LANGUAGES.includes(browserLanguage)) {
    return getMappedBrowserLanguage(browserLanguage as AllowedBrowserLanguage);
  }

  return Language.IT;
};
